import { createAction, props } from '@ngrx/store';
import { DeliveryRequest, PagedServices } from '../../models/delivery-request.model';
import { DeliveryResponse } from '../../models/delivery-response.model';

export const updateService = createAction(
  '[Service] Update Service',
  props<{ service: DeliveryRequest }>()
);

export const createService = createAction(
  '[Service] Create Service',
);

export const createServiceSuccess = createAction(
  '[Service] Create Service Success',
  props<{ service: DeliveryRequest }>()
);

export const createServiceFailure = createAction(
  '[Service] Create Service Failure',
  props<{ error: any }>()
);



export const loadServices = createAction(
  '[Service] Load Services',
  props<{ page: number, limit: number, query?: string }>()
);

export const loadServicesSuccess = createAction(
  '[Service] Load Services Success',
  props<{ services: PagedServices }>()
);

export const loadServicesFailure = createAction(
  '[Service] Load Services Failure',
  props<{ error: any }>()
);



export const editService = createAction(
  '[Service] Edit Service',
  props<{ id: number }>()
);

export const editServiceSuccess = createAction(
  '[Service] Edit Service Success',
  props<{ service: DeliveryRequest }>()
);

export const editServiceFailure = createAction(
  '[Service] Edit Service Failure',
  props<{ error: string }>()
);


export const setLoadingAction = createAction(
    '[DeliveryRequest] Set Loading',
    props<{ isLoading: boolean }>()
);

export const assignDeliveryRequest = createAction(
  '[Service] Assign Service',
  props<{ service_id: number, rider_id: number }>()
);

export const assignDeliveryRequestSuccess = createAction(
  '[Service] Assign Service Success',
  props<{ service: DeliveryRequest }>()
);

export const assignDeliveryRequestFailure = createAction(
  '[Service] Assign Service Failure',
  props<{ error: string }>()
);
  